// extracted by mini-css-extract-plugin
export default {"container":"component-layout-module--container--w+ygT"};